export const breakpoints = {
  breakMedium: '1023px',
  breakLarge: '1439px',
}
